/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingstepcompany2Inputs */

const en_onboardingstepcompany2 = /** @type {(inputs: Onboardingstepcompany2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing details`)
};

const de_onboardingstepcompany2 = /** @type {(inputs: Onboardingstepcompany2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsdaten`)
};

/**
* | output |
* | --- |
* | "Billing details" |
*
* @param {Onboardingstepcompany2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingstepcompany2 = /** @type {((inputs?: Onboardingstepcompany2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingstepcompany2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingstepcompany2(inputs)
	return de_onboardingstepcompany2(inputs)
});
export { onboardingstepcompany2 as "onboardingStepCompany" }